import script from "./TaskBudgetReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskBudgetReport.vue?vue&type=script&setup=true&lang=ts"

import "./TaskBudgetReport.vue?vue&type=style&index=0&id=66bf204d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bf204d"]])

export default __exports__